/**
 * On subpages if there is a Teaser on top, 
 * stick scrolling between first and second "page"
 */
(function() {
	var scrollOptions = {
		speed: 200
	};

	var teaser = document.querySelector('.text-teaser-big');
	if(!teaser) {
		return;
	}

	var body = document.querySelector('body');
	if(body.classList.contains('neos-backend')) {
		return;
	}

	window.addEventListener('scroll', onScroll);

	var scrollPosition = false;
	var scrollDirection = 'down';
	function onScroll() {
		requestAnimationFrame(function() {
			var newScrollPosition = window.pageYOffset || document.documentElement.scrollTop;;

			if (scrollPosition === newScrollPosition) {
				return;
			}

			if (newScrollPosition > scrollPosition) {
				scrollDirection = 'down';
			} else {
				scrollDirection = 'up';
			}
			scrollPosition = newScrollPosition;

			updateScrollPosition();
		});
	}

	var isScrolling = false;
	function updateScrollPosition() {
		if(isScrolling) {
			return;
		}

		var teaserHeight = teaser.getBoundingClientRect().height;
		if(teaser.classList.contains('align-text-teaser-big-for-subpage') && (window.innerHeight + 1) < teaserHeight) {
			return; // no need for this scrolling, we are on a subpage with a very small display
		}
		// if(!teaser.classList.contains('.align-text-teaser-big-for-subpage') && (window.innerHeight/2 + 1) < teaserHeight) {
		// currently fully disable on homepage
		if(!teaser.classList.contains('align-text-teaser-big-for-subpage')) {
			return; // no need for this scrolling, we are on the homepage with a very small display
		}

		var pageHeight = window.innerHeight;
		var navigationHeight = (window.innerWidth < 1180) ? 105 : 0;
		if(scrollDirection == 'down' && scrollPosition > 5 && scrollPosition < (pageHeight/2)) {
			// scroll down
			isScrolling = true;
			var myScrollOptions = JSON.parse(JSON.stringify(scrollOptions));
			myScrollOptions.onComplete = function() {
				// make sure to align for momentum scrolling
				var myScrollOptions = JSON.parse(JSON.stringify(scrollOptions));
				myScrollOptions.onComplete = function() {
					isScrolling = false;
				}
				animateScrollTo(pageHeight - navigationHeight - 10, myScrollOptions);
			};
			animateScrollTo(pageHeight - navigationHeight - 10, myScrollOptions);
		}
		
		if(scrollDirection == 'up' && scrollPosition > (pageHeight/2) && scrollPosition < (pageHeight - navigationHeight - 15)) {
			// scroll up
			isScrolling = true;
			var myScrollOptions = JSON.parse(JSON.stringify(scrollOptions));
			myScrollOptions.onComplete = function() {
				isScrolling = false;
			};
			animateScrollTo(0, myScrollOptions);
		}

		if(scrollDirection == 'up' && scrollPosition > pageHeight && scrollPosition < (pageHeight * 1.5 - navigationHeight)) {
			// scroll up to second page
			isScrolling = true;
			var myScrollOptions = JSON.parse(JSON.stringify(scrollOptions));
			myScrollOptions.onComplete = function() {
				isScrolling = false;
			};
			animateScrollTo(pageHeight - navigationHeight, myScrollOptions);
		}
	}

	updateScrollPosition();

}());
